// extracted by mini-css-extract-plugin
export default {"item":"Slider_item__t1Pb+","card":"Slider_card__qXRq6","slider":"Slider_slider__jHibB","sliderContainer":"Slider_sliderContainer__tDjAj"};